import { useEffect } from 'react';

/** Default matches Meta app; override with REACT_APP_FACEBOOK_APP_ID / REACT_APP_FACEBOOK_GRAPH_VERSION */
const DEFAULT_APP_ID = '2363189750873734';
const DEFAULT_GRAPH_VERSION = 'v21.0';

let fbInitDone = false;

/**
 * Loads connect.facebook.net/sdk.js once and calls FB.init (cookie + xfbml + AppEvents.logPageView).
 * Safe under React Strict Mode: init runs at most once.
 */
export function useFacebookSdk() {
  useEffect(() => {
    const appId = process.env.REACT_APP_FACEBOOK_APP_ID || DEFAULT_APP_ID;
    const version = process.env.REACT_APP_FACEBOOK_GRAPH_VERSION || DEFAULT_GRAPH_VERSION;

    const runInit = () => {
      if (fbInitDone || typeof window === 'undefined' || !window.FB) return;
      fbInitDone = true;
      window.FB.init({
        appId,
        cookie: true,
        xfbml: true,
        version,
      });
      if (window.FB.AppEvents && typeof window.FB.AppEvents.logPageView === 'function') {
        window.FB.AppEvents.logPageView();
      }
    };

    window.fbAsyncInit = function fbAsyncInit() {
      runInit();
    };

    if (document.getElementById('facebook-jssdk')) {
      if (window.FB) runInit();
      return undefined;
    }

    const script = document.createElement('script');
    script.id = 'facebook-jssdk';
    script.async = true;
    script.defer = true;
    script.crossOrigin = 'anonymous';
    script.src = 'https://connect.facebook.net/hu_HU/sdk.js';
    document.body.appendChild(script);

    return undefined;
  }, []);
}
